'use strict';

import debounce from 'debounce';

export default class imageContentCtrl {
  static get UID() {
    return 'imageContentCtrl';
  }

  constructor($window, $stateParams, $state, $scope, $sce, updateFac){
    Object.assign(this, { $window, $stateParams, $state, $sce, updateFac});

    $(document).keydown( debounce(this.keyEventHandler.bind(this), 500) );

    // Remove the event handler when we navigate away
    $scope.$on('$destroy', () => {
      $(document).off('keydown');
    });

    this.updateFac.getUpdate($stateParams.videoId)
      .then((response) => {
        this.update = response.data.data;

        let imageIdx = this.getImageIndex();

        // determine image shown
        this.image = this.update.images[imageIdx];

        if( !this.image ) return;

        this.image.idx = imageIdx + 1; // this is for display only
        this.image.total = this.update.images.length;

        $('div.image_list').animate({scrollTop: imageIdx * 142 - 20});

      });
  }

  getImageIndex() {
    if( !this.$stateParams || !this.$stateParams.imageIdx) return 0;

    let idx = parseInt(this.$stateParams.imageIdx, 10);

    if( isNaN(idx) ) return 0;

    return idx;
  }

  nextImage() {
    let idx = this.getImageIndex();

    if( !this.update ||  (idx + 1) >= this.update.images.length  ) return false;

    return idx + 1;
  }

  prevImage() { 
    let idx = this.getImageIndex();

    if( !this.update ||  (idx - 1) < 0 ) return false;

    return idx - 1;
  }

  keyEventHandler($e) {
    let key = $e.key;
    let idx;

    if( !key ) return false;

    switch( key.toLowerCase() ) {
      case 'arrowright' :
        this._goToImage(this.nextImage());
        break;

      case 'arrowleft' :
        this._goToImage(this.prevImage());
        break;

      default: 
        break;
    }
  }

  _goToImage(idx) {
    // NOTE: cannot just use !idx becuase idx can be 0
    if( idx !== null && idx !== undefined && idx !== false )
      this._pendingState = this.$state.go('image', { imageIdx: idx });
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/imageContent/imageContentCtrl.js